export default {
    withCredentials: false
};
